<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-left mt-4 text-center">
            <div class="bg-transparent card-header pt-4 border-0 hec-saving">
                <h4 class="h4 font-weight-normal text-primary text-center mb-0">
                     {{ $t('hec.application.title') }}
                </h4>
            </div>
            
            <div class="mb-5 hec-saving">
                <p v-html="$t('hec.application.applicationMessage')"></p>
            </div>

            <div class="mb-5 hec-saving">
                <p v-html="$t('hec.application.consentMessage')"></p>
            </div>

            <div class="mb-5 hec-saving">
                <p v-html="$t('hec.application.sendMessage')"></p>
            </div>

            <div class="mb-5 hec-saving">
                <p v-html="$t('hec.application.termsOfServiceMessage')"></p>
            </div>

            <div class="text-center mb-5 hec-saving">
                <a v-bind:href="this.hec_staking_url" class="nav-application">{{ $t('hec.application.linkMessage') }}</a>
            </div>

        </div>
    </div>
</template>

<script>
    import userService from '../../services/UserService';

    export default {
        components: {

        },
        data() {
            return {
                hec_staking_url: process.env.MIX_HEC_STAKING_URL,
            }
        },

        created() {
        },
        methods: {    
        },  
        computed: {
        },

    }
  
</script>

<style scoped>
    .hec-saving {
        margin-bottom: 20px!important;
    }
</style>
